import type { ReactNode } from 'react';

import { toArray } from '@repo/utils/to-array';

import type { FeatureGate } from '~/services/authorization/types.ts';

import { useFeatureGuard } from './use-feature-guard.ts';

export function FeatureGuard({
  mode = 'some',
  features,
  children,
}: { mode?: 'some' | 'all'; features: FeatureGate | FeatureGate[]; children: ReactNode }): ReactNode | undefined {
  const { hasSomeFeature, hasAllFeatures } = useFeatureGuard();
  const gates = toArray(features);
  const has = mode === 'some' ? hasSomeFeature(gates) : hasAllFeatures(gates);

  return has ? children : undefined;
}
